export const MOCK_ALLOCATION_CUSTOMERS = [
  { id: "cust-101", name: "Tata Power Enterprises Ltd" },
  { id: "cust-102", name: "L&T Construction Group Chennai" },
  { id: "cust-103", name: "Coimbatore Municipal Corporation" },
  { id: "cust-104", name: "Schneider Electric Systems India" },
  { id: "cust-105", name: "Reliance Industries Jamnagar" },
];
